import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import DropdownLink from 'components/DropdownLink';
import { useGoToOrderSettings } from 'catering/hooks/navigation';
function MenuLink({ menuName, fulfillmentMethod }) {
  const { locationSlug } = useParams();
  const goToOrderSettings = useGoToOrderSettings();

  const handleMenuLinkClick = () => {
    goToOrderSettings({
      locationSlug,
      fulfillmentMethod
    });
  };

  return <DropdownLink label={menuName} onClick={handleMenuLinkClick} />;
}

MenuLink.propTypes = {
  menuName: PropTypes.string.isRequired,
  fulfillmentMethod: PropTypes.string.isRequired
};

export default MenuLink;
